/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 28d8341d0746c8b74890356e7694f744 */

import { ConcreteRequest } from "relay-runtime";

import {  } from "relay-runtime";
export type HeaderRefetchQueryVariables = {
    userId: string;
    userIds: Array<string | null>;
    isClient: boolean;
    hasUserId: boolean;
    hasTradeUserId: boolean;
    fetchRegionalInfo: boolean;
    previewKey?: string | null | undefined;
    zipCode: string;
    userCountryCode?: string | null | undefined;
    hasSessionCountryCode: boolean;
    localRecentHistoryItemIds?: Array<string | null> | null | undefined;
    fetchUserRecentHistoryItem?: boolean | null | undefined;
    checkoutUserId: string;
    hasCheckoutUserId: boolean;
};
export type HeaderRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Header_viewer">;
    };
};
export type HeaderRefetchQuery = {
    readonly response: HeaderRefetchQueryResponse;
    readonly variables: HeaderRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "checkoutUserId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchRegionalInfo"
    } as any, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "fetchUserRecentHistoryItem"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasCheckoutUserId"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSessionCountryCode"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasTradeUserId"
    } as any, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasUserId"
    } as any, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isClient"
    } as any, v8 = {
        "defaultValue": ([] /*: any*/),
        "kind": "LocalArgument",
        "name": "localRecentHistoryItemIds"
    } as any, v9 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "previewKey"
    } as any, v10 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "userCountryCode"
    } as any, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    } as any, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIds"
    } as any, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "zipCode"
    } as any, v14 = {
        "alias": "isAutomatedOfferNotificationDisabled",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "disableAutomatedOfferBellNotification"
            }
        ],
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v16 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "path",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLinkable",
            "storageKey": null
        } as any
    ], v17 = {
        "alias": null,
        "args": null,
        "concreteType": "LinkData",
        "kind": "LinkedField",
        "name": "linkData",
        "plural": false,
        "selections": (v16 /*: any*/),
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
    } as any, v20 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "showUnreadOnly"
        } as any
    ], v21 = {
        "kind": "Literal",
        "name": "first",
        "value": 3
    } as any, v22 = {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVip",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVerifiedTrade",
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            (v25 /*: any*/)
        ],
        "storageKey": null
    } as any, v27 = [
        {
            "kind": "Variable",
            "name": "excludeItemPks",
            "variableName": "localRecentHistoryItemIds"
        } as any,
        {
            "kind": "Literal",
            "name": "first",
            "value": 12
        } as any
    ], v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v29 = [
        (v19 /*: any*/),
        (v18 /*: any*/)
    ], v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profileStatus",
        "storageKey": null
    } as any, v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "concreteType": "TradeFirmRewards",
        "kind": "LinkedField",
        "name": "rewards",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ParentProgram",
                "kind": "LinkedField",
                "name": "currentProgram",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LoyaltyProgram",
                        "kind": "LinkedField",
                        "name": "programInfo",
                        "plural": false,
                        "selections": [
                            (v33 /*: any*/),
                            (v18 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "buyerDisplayable",
        "storageKey": null
    } as any, v36 = {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareActivities",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v37 = {
        "alias": null,
        "args": null,
        "concreteType": "Summary",
        "kind": "LinkedField",
        "name": "conversationSummary",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unread",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v38 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v39 = {
        "kind": "InlineFragment",
        "selections": [
            (v18 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v40 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
    } as any, v41 = [
        (v25 /*: any*/),
        (v40 /*: any*/)
    ], v42 = [
        {
            "kind": "Literal",
            "name": "elementTypes",
            "value": [
                "PENDING_FEEDBACK",
                "TRADE_REWARD",
                "TRADE_REWARD_PRORATED",
                "TRADE_REWARD_PROGRAM",
                "AUTOMATED_OFFER"
            ]
        } as any,
        (v21 /*: any*/)
    ], v43 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v44 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventDate",
        "storageKey": null
    } as any, v45 = {
        "alias": "thumbnail",
        "args": [
            {
                "kind": "Literal",
                "name": "size",
                "value": "thumb"
            }
        ],
        "kind": "ScalarField",
        "name": "firstPhotoWebPath",
        "storageKey": "firstPhotoWebPath(size:\"thumb\")"
    } as any, v46 = {
        "kind": "Variable",
        "name": "zipCode",
        "variableName": "zipCode"
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/),
                (v7 /*: any*/),
                (v8 /*: any*/),
                (v9 /*: any*/),
                (v10 /*: any*/),
                (v11 /*: any*/),
                (v12 /*: any*/),
                (v13 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "HeaderRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Header_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v11 /*: any*/),
                (v12 /*: any*/),
                (v7 /*: any*/),
                (v6 /*: any*/),
                (v5 /*: any*/),
                (v1 /*: any*/),
                (v9 /*: any*/),
                (v13 /*: any*/),
                (v10 /*: any*/),
                (v4 /*: any*/),
                (v8 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Operation",
            "name": "HeaderRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "emailLinkLoginFF",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "feature",
                                    "value": "emailLinkLogin"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "featureFlag",
                            "storageKey": "featureFlag(feature:\"emailLinkLogin\")"
                        },
                        (v14 /*: any*/),
                        {
                            "alias": "footerSupportLinks",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "feature",
                                    "value": "footerSupportLinks"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "featureFlag",
                            "storageKey": "featureFlag(feature:\"footerSupportLinks\")"
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "rootId",
                                    "variableName": "previewKey"
                                }
                            ],
                            "concreteType": "Navigation",
                            "kind": "LinkedField",
                            "name": "navigation",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NavigationModule",
                                    "kind": "LinkedField",
                                    "name": "modules",
                                    "plural": true,
                                    "selections": [
                                        (v15 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "NavigationTopLevel",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                (v15 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "column",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "NavigationItem",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": true,
                                                    "selections": [
                                                        (v15 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v18 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageUrl",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LinkData",
                                            "kind": "LinkedField",
                                            "name": "imageLinkData",
                                            "plural": false,
                                            "selections": (v16 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageTitlePrimary",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageTitleSecondary",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageHeight",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageWidth",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageLink",
                                            "storageKey": null
                                        },
                                        (v17 /*: any*/),
                                        (v19 /*: any*/),
                                        (v18 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v18 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v18 /*: any*/),
                        {
                            "condition": "isClient",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "relayIsClient",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                {
                                    "if": null,
                                    "kind": "Defer",
                                    "label": "AccountNav_viewer$defer$AccountNavContent_viewer",
                                    "selections": [
                                        {
                                            "alias": "nftMarketplaceEnabled",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "feature",
                                                    "value": "nftMarketplace"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "featureFlag",
                                            "storageKey": "featureFlag(feature:\"nftMarketplace\")"
                                        },
                                        {
                                            "alias": "nftPublicProfileEnabled",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "feature",
                                                    "value": "nftPublicProfile"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "featureFlag",
                                            "storageKey": "featureFlag(feature:\"nftPublicProfile\")"
                                        }
                                    ]
                                },
                                {
                                    "if": null,
                                    "kind": "Defer",
                                    "label": "Notifications_viewer$defer$ActivityFeed_viewer",
                                    "selections": [
                                        {
                                            "alias": "promoCodeMessaging",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "feature",
                                                    "value": "promoCodeMessaging"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "featureFlag",
                                            "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
                                        },
                                        (v14 /*: any*/)
                                    ]
                                },
                                {
                                    "if": null,
                                    "kind": "Defer",
                                    "label": "Notifications_initialViewer$defer$Conversations_viewer",
                                    "selections": [
                                        {
                                            "condition": "hasUserId",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": (v20 /*: any*/),
                                                    "concreteType": "ConversationConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conversations",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ConversationMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "metadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "totalUnreadConversationCount",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "conversations(filter:\"showUnreadOnly\")"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "if": null,
                                    "kind": "Defer",
                                    "label": "Notifications_initialViewer$defer$NotificationsIcon_viewer",
                                    "selections": [
                                        (v14 /*: any*/),
                                        {
                                            "condition": "hasUserId",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": (v20 /*: any*/),
                                                    "concreteType": "ConversationConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conversations",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ConversationMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "metadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "lastUnreadMessageDate",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "conversations(filter:\"showUnreadOnly\")"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "if": null,
                                    "kind": "Defer",
                                    "label": "Header_viewer$defer$userTracking_viewer",
                                    "selections": [
                                        {
                                            "condition": "hasCheckoutUserId",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "buyerId",
                                                            "variableName": "checkoutUserId"
                                                        }
                                                    ],
                                                    "concreteType": "TransactionsCounter",
                                                    "kind": "LinkedField",
                                                    "name": "transactionsCounter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "guestCheckoutTransactions",
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "guest",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "condition": "hasUserId",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "submittedTransactions",
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "submitted",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": "confirmedTransactions",
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "confirmed",
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "CART"
                                            ]
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "userIds",
                                            "variableName": "userIds"
                                        }
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "kind": "LinkedField",
                                    "name": "portfolios",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v21 /*: any*/)
                                                            ],
                                                            "concreteType": "PortfolioItemsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "totalResults",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "items(first:3)"
                                                        },
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v22 /*: any*/)
                                    ],
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v18 /*: any*/),
                                        (v23 /*: any*/),
                                        (v24 /*: any*/),
                                        (v26 /*: any*/),
                                        {
                                            "if": null,
                                            "kind": "Defer",
                                            "label": "SearchBar_viewer$defer$getRecentHistory_user",
                                            "selections": [
                                                {
                                                    "condition": "fetchUserRecentHistoryItem",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": (v27 /*: any*/),
                                                            "concreteType": "RecentHistoryItemsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "recentHistoryItems",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "RecentHistoryItemsEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Item",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "contemporaryTrackingString",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "size",
                                                                                            "value": "small"
                                                                                        }
                                                                                    ],
                                                                                    "kind": "ScalarField",
                                                                                    "name": "firstPhotoWebPath",
                                                                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pdpURL",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v28 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "browseUrl",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "categoryCode",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v19 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "categoryPath",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Seller",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "seller",
                                                                                    "plural": false,
                                                                                    "selections": (v29 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v18 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "cursor",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "endCursor",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v27 /*: any*/),
                                                            "filters": [
                                                                "excludeItemPks"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "getRecentHistory_recentHistoryItems",
                                                            "kind": "LinkedHandle",
                                                            "name": "recentHistoryItems"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "if": null,
                                            "kind": "Defer",
                                            "label": "Header_viewer$defer$userTracking_user",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "createdDate",
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "verifiedTradeStatus",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UserExistsMetadataType",
                                                    "kind": "LinkedField",
                                                    "name": "authMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emailOnly",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "hasPassword",
                                                            "storageKey": null
                                                        },
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Profile",
                                                    "kind": "LinkedField",
                                                    "name": "profile",
                                                    "plural": false,
                                                    "selections": [
                                                        (v31 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "zipCode",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v26 /*: any*/),
                                                (v19 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "totalMessagesToDealers",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TradeFirmType",
                                                    "kind": "LinkedField",
                                                    "name": "tradeFirm",
                                                    "plural": false,
                                                    "selections": [
                                                        (v19 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "mentionMeTagParameters",
                                                    "kind": "LinkedField",
                                                    "name": "mentionMeTagParameters",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "ciphertext",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "nonce",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Promotion",
                                                    "kind": "LinkedField",
                                                    "name": "activePromotion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "campaignName",
                                                            "storageKey": null
                                                        },
                                                        (v35 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isClient",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                (v36 /*: any*/),
                                                {
                                                    "condition": "hasTradeUserId",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "if": null,
                                                            "kind": "Defer",
                                                            "label": "AccountNav_user$defer$AccountNavContent_user",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Profile",
                                                                    "kind": "LinkedField",
                                                                    "name": "profile",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v31 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v37 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "if": null,
                                                    "kind": "Defer",
                                                    "label": "AccountNav_user$defer$AccountNavTrigger_user",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Profile",
                                                            "kind": "LinkedField",
                                                            "name": "profile",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "firstName",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v24 /*: any*/),
                                                        {
                                                            "condition": "hasTradeUserId",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TradeFirmRewards",
                                                                    "kind": "LinkedField",
                                                                    "name": "tradeFirmRewards",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "currentYearPoints",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ParentProgram",
                                                                            "kind": "LinkedField",
                                                                            "name": "currentProgram",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "LoyaltyProgram",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "programInfo",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v38 /*: any*/),
                                                                                        (v18 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "hasTradeUserId",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "if": null,
                                                            "kind": "Defer",
                                                            "label": "AccountNav_user$defer$TradeAccountNavContent_user",
                                                            "selections": [
                                                                (v19 /*: any*/),
                                                                (v24 /*: any*/),
                                                                (v37 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TradeFirmType",
                                                                    "kind": "LinkedField",
                                                                    "name": "tradeFirm",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v19 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TradeFirmPublicProfileType",
                                                                            "kind": "LinkedField",
                                                                            "name": "publicProfile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "urlLabel",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TradeFirmMemberType",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "userId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "publicProfileManager",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v18 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v18 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isClient",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "if": null,
                                                            "kind": "Defer",
                                                            "label": "Notifications_user$defer$ShareActivityAlert_user",
                                                            "selections": [
                                                                (v19 /*: any*/),
                                                                (v36 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "if": null,
                                                            "kind": "Defer",
                                                            "label": "Notifications_user$defer$ActivityFeed_user",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Promotion",
                                                                    "kind": "LinkedField",
                                                                    "name": "activePromotion",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v35 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PromotionMeta",
                                                                            "kind": "LinkedField",
                                                                            "name": "promotionMeta",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "displayMessage",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "displayCta",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "adjustmentRateList",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v30 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "reference",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v39 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v33 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "FlatAdjustmentRate",
                                                                            "kind": "LinkedField",
                                                                            "name": "flatAdjustmentRate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "FinancialAmount",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "rate",
                                                                                    "plural": false,
                                                                                    "selections": (v41 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v18 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PercentAdjustmentRate",
                                                                            "kind": "LinkedField",
                                                                            "name": "percentAdjustmentRate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "rate",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v18 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v18 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v42 /*: any*/),
                                                                    "concreteType": "ActivityFeedConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "activityFeed",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ActivityFeedEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ActivityFeedElement",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v43 /*: any*/),
                                                                                        (v44 /*: any*/),
                                                                                        (v19 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "apiType",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "status",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Anchor",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "anchors",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "sourceType",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": null,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "source",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v30 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v19 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "FinancialAmount",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "rewardEarned",
                                                                                                                    "plural": false,
                                                                                                                    "selections": (v41 /*: any*/),
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "TradeFirmReward",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "LoyaltyProgram",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "programInfo",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v38 /*: any*/),
                                                                                                                        (v33 /*: any*/),
                                                                                                                        (v18 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "ParentProgram",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "token",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Transaction",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "transaction",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "Item",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "item",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                (v28 /*: any*/),
                                                                                                                                (v45 /*: any*/),
                                                                                                                                (v18 /*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v18 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "OrderFeedback",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v19 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "TransactionSummaryObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summary",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "offerDiscountPercentage",
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Item",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "item",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v28 /*: any*/),
                                                                                                                        (v45 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "ItemPricing",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "pricing",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "FinancialAmount",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "retailPrice",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "ConvertedAmountList",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "convertedAmountList",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                (v40 /*: any*/),
                                                                                                                                                (v25 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v18 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Offer",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "mostRecentOffer",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "FinancialAmount",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "amountPerItem",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "ConvertedAmountList",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "convertedAmountList",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": (v41 /*: any*/),
                                                                                                                                    "storageKey": null
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v18 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Conversation",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "conversation",
                                                                                                                    "plural": false,
                                                                                                                    "selections": (v29 /*: any*/),
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "Transaction",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        (v39 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v18 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "if": null,
                                                            "kind": "Defer",
                                                            "label": "Notifications_user$defer$NotificationsIcon_user",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Promotion",
                                                                    "kind": "LinkedField",
                                                                    "name": "activePromotion",
                                                                    "plural": false,
                                                                    "selections": (v29 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v42 /*: any*/),
                                                                    "concreteType": "ActivityFeedConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "activityFeed",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ActivityFeedEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ActivityFeedElement",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v43 /*: any*/),
                                                                                        (v44 /*: any*/),
                                                                                        (v18 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "condition": "hasSessionCountryCode",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "regInfo",
                                    "args": null,
                                    "concreteType": "RegionalInfo",
                                    "kind": "LinkedField",
                                    "name": "regionalInfo",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "countryCode",
                                            "storageKey": null
                                        },
                                        (v18 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "condition": "fetchRegionalInfo",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "countryCode",
                                            "variableName": "userCountryCode"
                                        },
                                        (v22 /*: any*/),
                                        (v46 /*: any*/)
                                    ],
                                    "concreteType": "RegionalInfo",
                                    "kind": "LinkedField",
                                    "name": "regionalInfo",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": [
                                                (v46 /*: any*/)
                                            ],
                                            "concreteType": "IncomeLevel",
                                            "kind": "LinkedField",
                                            "name": "incomeLevel",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "incomeBracket",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "incomePercentile",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v25 /*: any*/),
                                        (v18 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/HeaderRefetchQuery",
            "metadata": {},
            "name": "HeaderRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'a0d733d1b87ad2170679c3bbb15af140';
export default node;
